import React from 'react';
import Icon from '../../../components/AppIcon';

const VOID_BG = '#080810';
const CYAN = '#00FFE5';
const ICE = '#E8F4FF';
const MUTED = '#8899AA';
const MONO = "'JetBrains Mono', 'Courier New', monospace";

const SocialRegistration = ({ onSocialRegister, isLoading }) => {
  const socialProviders = [
    { id: 'google', name: 'GOOGLE', icon: 'Chrome' },
  ];

  return (
    <div className="w-full max-w-md mx-auto mb-8">
      <div className="space-y-3">
        {socialProviders?.map((provider) => (
          <button
            key={provider?.id}
            onClick={() => onSocialRegister?.(provider?.id)}
            disabled={isLoading}
            className="w-full flex items-center justify-center gap-3 py-3 transition-all"
            style={{ background: 'transparent', border: '1px solid rgba(0,255,229,0.3)', color: CYAN, fontFamily: MONO, fontSize: '0.72rem', letterSpacing: '0.1em', textTransform: 'uppercase', cursor: isLoading ? 'not-allowed' : 'pointer', opacity: isLoading ? 0.6 : 1 }}
            onMouseEnter={e => { if (!isLoading) e.currentTarget.style.borderColor = CYAN; }}
            onMouseLeave={e => e.currentTarget.style.borderColor = 'rgba(0,255,229,0.3)'}
          >
            <Icon name={provider?.icon} size={16} />
            CONTINUE WITH {provider?.name}
          </button>
        ))}
      </div>
      <div className="relative my-8">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full" style={{ borderTop: '1px solid rgba(0,255,229,0.15)' }} />
        </div>
        <div className="relative flex justify-center">
          <span style={{ background: VOID_BG, padding: '0 12px', color: MUTED, fontFamily: MONO, fontSize: '0.65rem', letterSpacing: '0.1em', textTransform: 'uppercase' }}>
            OR REGISTER DIRECTLY
          </span>
        </div>
      </div>
    </div>
  );
};

export default SocialRegistration;
